export { ConfigLabelPipe } from './lib/config-label.pipe';
export { ConfigFormControlDirective } from './lib/config-form-control.directive';
export { ConfigResolverService } from './lib/config-resolver.service';
export {
  ConfigPartnerLogoPipe,
  ConfigPartnerShowProductIconPipe,
} from './lib/config-partner.pipe';
export * from './lib/form-config';
